import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from '../../../../i18next';

import {
    loadTenderTypeMapping,
    updateTenderTypeMapping,
    loadPosTenderTypes,
    importPosTenderTypes
} from "../../../../actions/index";
import MappingTypes from './MappingTypes';


class TenderTypeMappingScreen extends Component {
    constructor(props) {
        super(props);

        this.updateTenderTypeMapping = this.updateTenderTypeMapping.bind(this);
        this.importAllPosTenderTypes = this.importAllPosTenderTypes.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        this.props.loadTenderTypeMapping(id);
        this.props.loadPosTenderTypes(id);
    }

    updateTenderTypeMapping(mappingTypes) {
        const { id } = this.props.match.params;
        this.props.updateTenderTypeMapping(this.transformMappingTypes(mappingTypes), id);
    }

    transformMappingTypes(mappingTypes) {
        const updatedMappings = [];

        mappingTypes.map(mapping => {
            const currentMapping = {
                id: mapping.id,
                tenderType: {
                    id: mapping.mappingType.id,
                    value: mapping.mappingType.value
                },
                posTenderType: {
                    id: mapping.posType.id,
                    value: mapping.posType.value,
                    posId: mapping.posType.posId
                }
            }
            updatedMappings.push(currentMapping);
        });

        return updatedMappings;
    }

    importAllPosTenderTypes() {
        const { id } = this.props.match.params;
        this.props.importPosTenderTypes(id);
    }

    render() {
        const translationData = {
            heading: i18n.t('screens:restaurantsMainContainer.tendertype'),
            firstLabel: i18n.t('screens:tenderTypeMappingScreen.tenderType'),
            secondLabel: i18n.t('screens:tenderTypeMappingScreen.posTenders')
        }
        return (
            
            <MappingTypes
                params={this.props.match.params}
                mappingTypes={this.props.tenderTypeMappings}
                update={this.updateTenderTypeMapping}
                posTypes={this.props.tenderPosTypes}
                import={this.importAllPosTenderTypes}
                posSettings={this.props.posSettings}
                translations={translationData}
            />
        );
    }
}


const mapStateToProps = state => {
    return {
        restaurants: state.restaurants,
        tenderTypeMappings: state.tenderTypeMappings,
        tenderPosTypes: state.tenderPosTypes,
        posSettings: state.posSettings
    }
}

export default connect(
    mapStateToProps,
    {
        loadTenderTypeMapping,
        updateTenderTypeMapping,
        loadPosTenderTypes,
        importPosTenderTypes
    }
)(TenderTypeMappingScreen);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/pos/TenderTypeMappingScreen.js